<template>
  <div class="page-positions shared-index">
    <h3 class="m-0">Bảng giá theo vị trí banner</h3>
    <el-row class="table-title" type="flex" align="center" justify="space-between">
      <div class="table-title__left">
        <el-tabs :value="activeTab" type="card">
          <el-tab-pane
            v-for="position in listPositions"
            :name="`${position.id}`"
            :key="position.id">
            <div slot="label">
              {{ `Banner ${position.id}` }}
              <span v-if="`${position.id}` === activeTab">({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          disabled
          @click="handleOpenFormPopup()"
        >Thêm giá</el-button>
      </div>
    </el-row>
    <div v-loading="callingAPI" class="table">
      <list-prices
        :data="prices"
        :loading="loading"
        @delete="handleDelete"
        @edit="handleOpenFormPopup"
      ></list-prices>
    </div>
    <price-form-popup
      v-if="visible"
      :visible="visible"
      :price="price"
      @reload="handleReload"
      @close="visible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ListPrices from './prices/List'
import PriceFormPopup from './popups/PriceForm.vue'

export default {
  name: 'OrgUsers',
  components: {
    ListPrices,
    PriceFormPopup
  },
  props: {
    page: Object
  },
  data() {
    return {
      activeTab: null,
      loading: false,
      visible: false,
      price: null,
      callingAPI: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    listPositions() {
      return this.page.positions
    },
    prices() {
      return this.listPositions.find((p) => p.id === Number(this.activeTab)).prices || []
    },
    total() {
      return this.listPositions.length
    }
  },

  beforeMount() {
    this.activeTab = `${this.listPositions[0].id}`
  },

  methods: {
    handleReload() {},
    handleOpenFormPopup(price = null) {
      this.price = price
      this.visible = true
    },
    handleDelete(price) {
      this.$confirm('Bạn có chắc chắn muốn xoá vị trí?', 'Cảnh báo', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.loading = true
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
